import { render, staticRenderFns } from "./DeleteIncompleteArchiveDialogBox.vue?vue&type=template&id=61b60049&scoped=true&"
import script from "./DeleteIncompleteArchiveDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteIncompleteArchiveDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b60049",
  null
  
)

export default component.exports